<!--  -->
<template>
  <div>
    <el-form
      :label-position="'right'"
      label-width="80px"
    >
      <!-- <el-form-item label="账户ID">
        <el-input
          v-model="account_id"
          :disabled="addtype === 2"
        />
      </el-form-item> -->
      <el-form-item label="类型">
        <el-select
          v-model="account_type"
          placeholder="请选择类型"
          :disabled="addtype === 2"
        >
          <el-option
            label="ADX"
            :value="1"
          />
          <el-option
            label="变色龙"
            :value="2"
          />
          <el-option
            label="ADX_KAFKA"
            :value="3"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="账户名称">
        <el-input
          v-model="user_name"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item label="账户密码">
        <el-input
          v-model="user_password"
          show-password
          autocomplete="new-password"
        />
      </el-form-item>
      <el-form-item v-if="account_type == 3" label="公网地址">
        <el-input
          v-model="address"
        />
      </el-form-item>
      <el-form-item v-if="account_type == 3" label="主题">
        <el-input
          v-model="topic"
        />
      </el-form-item>
      <el-form-item v-if="account_type == 3" label="消费组">
        <el-input
          v-model="consumer_group"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { adxaccountcreate, adxaccountupdate } from '@/api/report/adx'
export default {
  components: {},
  data() {
    return {
      addtype: null,
      // account_id: '',
      account_type: 1,
      user_name: '',
      user_password: '',
      // account_info: {
      //   username: '',
      //   password: ''
      // },
      id: null,
      address: '',
      topic: '',
      consumer_group: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      this.addtype = type
      if (this.addtype === 2) {
        this.id = item.id
        console.log('item', item)
        this.account_id = item.account_id
        this.account_type = item.account_type
        // const obj = JSON.parse(item.account_info)
        // this.account_info = obj
        this.user_name = item.user_name
        this.user_password = item.user_password
        // eslint-disable-next-line eqeqeq
        if (item.account_type == 3) {
          this.address = item.address
          this.topic = item.topic
          this.consumer_group = item.consumer_group
        }
      }
    },
    async sumbitr() {
      // if (this.account_id === '') {
      //   this.$message.error('请输入账户ID')
      //   return
      // }
      if (this.user_name === '') {
        this.$message.error('请输入账户名称')
        return
      }
      if (this.user_password === '') {
        this.$message.error('请输入账户密码')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.account_type == 3) {
        // eslint-disable-next-line eqeqeq
        if (this.address == '') {
          this.$message.error('请输入公网地址')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.topic == '') {
          this.$message.error('请输入主题')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.consumer_group == '') {
          this.$message.error('请输入消费组')
          return
        }
      }
      const obj = {}
      // eslint-disable-next-line eqeqeq
      if (this.account_type == 3) {
        obj.address = this.address
        obj.topic = this.topic
        obj.consumer_group = this.consumer_group
      }

      if (this.addtype === 1) {
        const data = await adxaccountcreate({
          // account_id: this.account_id,
          account_type: this.account_type,
          user_name: this.user_name,
          user_password: this.user_password,
          ...obj
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        const data = await adxaccountupdate({
          // id: this.id,
          // account_id: this.account_id,
          account_type: this.account_type,
          user_name: this.user_name,
          user_password: this.user_password,
          ...obj
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
